// Helper para formatear fechas sin conversión de timezone
export const formatDateLocal = (dateString) => {
    if (!dateString) return '';
    
    // Extraer solo la parte de fecha (YYYY-MM-DD)
    const datePart = dateString.split('T')[0];
    const [year, month, day] = datePart.split('-');
    
    // Crear fecha en formato local sin conversión de timezone
    return new Date(year, month - 1, day).toLocaleDateString('es-SV', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
};